import { type LBIcon } from '@/assets/icons/icons';

interface SidebarAddRowProps {
  icon: LBIcon;
  label: string;
  onClick: () => void;
}

export function SidebarAddRow({
  icon: Icon,
  label,
  onClick,
}: SidebarAddRowProps) {
  return (
    <button
      type="button"
      className="focus-ring-inset flex w-full items-center gap-2 rounded-md px-3 py-1.5 text-sm text-foreground-subtle transition-colors hover:bg-surface-hover hover:text-foreground"
      onClick={onClick}
    >
      <Icon className="size-3.5 shrink-0" />
      <span>{label}</span>
    </button>
  );
}
